// 导出版本号
export const version = "1.0.5";

export * from './core/base';
export * from './core/type';
export * from './scrollbar';
export * from './tag';
export * from './poptip';
export * from './crosshair';
export * from './label';
export * from './axis';
export * from './axis/grid';
export * from './segment';
export * from './data-zoom';
export * from './marker';
export * from './pager';
export * from './legend';
export * from './title';
export * from './indicator';
export * from './slider';
export * from './link-path';
export * from './player';
export * from './brush';
export * from './tooltip';
export * from './timeline';
export * from './interface';
export * from './jsx';
export * from './checkbox';
export * from './radio';
export * from './empty-tip';
export * from './weather';
export * from './util';
export * from './switch';
export * from './label-item';
